import { supabase } from './supabaseClient';
import { brandToSlug } from '../utils/brands';

export async function fetchStorefrontBrands() {
  if (!supabase) return [];

  const { data, error } = await supabase
    .from('brands')
    .select('id, name, slug, display_order, visible, description')
    .eq('visible', true)
    .order('display_order', { ascending: true });

  if (error) {
    if (/brands/i.test(error.message || '')) return [];
    throw error;
  }

  return data || [];
}

export async function fetchAllBrands() {
  if (!supabase) return [];

  const { data, error } = await supabase
    .from('brands')
    .select('*')
    .order('display_order', { ascending: true });

  if (error) throw error;
  return data || [];
}

export function findBrandRecord(brands, brandSlug) {
  const slug = String(brandSlug || '').trim();
  if (!slug) return null;
  return (brands || []).find(brand => brand.slug === slug) || null;
}

export function normalizeBrandSlug(name) {
  return brandToSlug(name);
}
